import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import './button.scss';

class Button extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        const {
            field,
            form,
            onClick,
            type,
            value,
        } = this.props;

        if (type === 'submit' && value && form && form.isValid) {
            form.setFieldValue(field.name, value);
        }

        onClick(event);
    }

    render() {
        const {
            appearance,
            children,
            href,
            field,
            form,
            onClick,
            value,
            ...other
        } = this.props;
        const className = classNames('button', {
            [`button--${appearance}`]: true,
        });

        return (
            href ?
                <Link
                    className={className}
                    to={href}
                >
                    {children}
                </Link>
                :
                <button
                    className={className}
                    onClick={this.handleClick}
                    {...other}
                    value={value}
                >
                    {children}
                </button>
        );
    }
}

Button.propTypes = {
    appearance: PropTypes.oneOf([
        'primary',
        'primary-alt',
        'danger',
        'secondary',
        'secondary-danger',
        'tertiary',
        'tertiary-alt',
        'tertiary-light',
        'icon',
    ]),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    field: PropTypes.shape({
        name: PropTypes.string,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        value: PropTypes.string,
    }),
    form: PropTypes.shape({
        errors: PropTypes.objectOf(PropTypes.string),
        touched: PropTypes.objectOf(PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.shape({}),
            PropTypes.array,
        ])),
    }),
    href: PropTypes.string,
    onClick: PropTypes.func,
    type: PropTypes.oneOf(['button', 'submit']),
    value: PropTypes.string,
};

Button.defaultProps = {
    appearance: 'primary',
    field: {},
    form: {},
    href: null,
    onClick: () => {
    },
    type: 'button',
    value: '',
};

export default Button;
